import { GRID_PRESETS, SHARED_COMPOSITIONS } from './compositionLayouts';

/**
 * Tuiles palette « Bannière d'accueil » / « Bannière d'action » /
 * « Image + Texte » / « Vidéo + Texte » / « Chiffres clés » /
 * « Questions / réponses » / « Équipe » / « Bandeau de logos » /
 * « Témoignages » —
 * purs MACROS de composition : le bloc inséré est immédiatement remplacé
 * (PuckPageEditor onAction → pagePuckData) par une vraie Section pré-remplie
 * à la racine. Aucun rendu propre, aucune donnée persistée sous ces types.
 */
const macroConfig = (label) => ({
  label,
  defaultProps: {},
  fields: {},
  render: () => null,
});

export const heroMacroConfig = macroConfig("Bannière d'accueil");
export const actionBannerMacroConfig = macroConfig("Bannière d'action");
export const keyFiguresMacroConfig = macroConfig('Chiffres clés');
export const faqMacroConfig = macroConfig('Questions / réponses');
export const logoStripMacroConfig = macroConfig('Bandeau de logos');

/**
 * Tuiles des grilles vides : mêmes libellés que le sélecteur de disposition
 * d'un Bloc, puisque ce sont les mêmes grilles.
 */
export const gridPresetConfigs = Object.fromEntries(
  GRID_PRESETS.map(({ type, label }) => [type, macroConfig(label)]),
);

/**
 * Tuiles des compositions reprises du catalogue partagé avec l'éditeur
 * classique : même mécanique, mais elles posent des box VIDES. Leur libellé
 * vient du catalogue — la même disposition porte le même nom des deux côtés.
 */
export const sharedCompositionConfigs = Object.fromEntries(
  SHARED_COMPOSITIONS.map(({ type, label }) => [type, macroConfig(label)]),
);

/*
 * Tuiles du presse-papier : même mécanique, hors catégorie — la palette les
 * rend elle-même quand une copie attend (blockClipboard), et la tuile est
 * remplacée au drop par le bloc copié.
 */
export const clipboardSectionTileConfig = macroConfig('Copie de bloc');
export const clipboardBoxTileConfig = macroConfig('Copie de box');
